module.exports = __webpack_public_path__ + "static/media/2022-Bikie-Code-Feature-banner-Desktop@2x.c9fa0b83.jpg";